import successReducer from './success-reducer';

export default successReducer;
